export default __webpack_public_path__ + "locales/tr/ChangePasswordDialog.json?hash=9bd7dbcbecda50d893eaf23b4569256f";